export const VerifyCodeType = {
	REGISTER: 1,		// 註冊
	CHANGE: 2, 		// 更換
}

export const InvoiceState = {
	PLATFORM_CARRIER: '0',		// 平台載具
	CARRIER: '1',				// 手機載具
	TAX_NUMBER: '2',			// 統編
}
